import { KeyPhraseSynonymsState } from 'src/react/keyPhraseSynonyms/state/KeyPhraseSynonymsState';

export const KEY_PHRASE_SYNONYMS_DEFAULT_STATE: KeyPhraseSynonymsState = {
    duplicates: [],
};
